import { isNil } from "lodash";
import React from "react";

const MaxWidthLabel: React.FC<{
  label: string;
  width: number;
}> = (props): JSX.Element => {
  if (!isNil(props.label) && props.label.length > props.width) {
    return (
      <div className="ui label" data-tooltip={props.label}>
        {props.label.substring(0, props.width)}...
      </div>
    );
  } else {
    return <div className="ui label">{props.label}</div>;
  }
};

export default MaxWidthLabel;
